module.exports = __webpack_public_path__ + "static/media/illustration_gig.686aa42a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustration_gig.svg
// module id = 340
// module chunks = 21